<template>
  <portal to="ModalRecommendation">
    <div class="modal-backdrop pt-xl-4">
      <div class="wrapper">
        <div class="card mx-auto">
          <div class="d-flex justify-content-end pt-2 pr-2">
            <a @click="$emit('close', 'editCp')">
              <img
                src="@/assets/icon/close.png"
                alt="close"
              >
            </a>
          </div>
          <div class="card-body overflow-auto">
            <div class="text-center mt-3 mb-5 px-2">
              <h5 class="font-weight-bold">
                {{ $t('manage-master-data.contact-person.head') }}
              </h5>
            </div>
            <div
              v-if="isLoadingGet"
              class="text-center mt-5"
            >
              <div class="spinner-border spinner-border-sm">
                <span class="sr-only">
                  Loading...
                </span>
              </div>
            </div>
            <div
              v-else
              class="p-3 p-sm-4 p-lg-5"
            >
              <div class="row">
                <div class="col-lg-6 mb-2">
                  <small class="font-weight-bold">
                    {{ $t('manage-master-data.company.label.company') }}
                  </small>
                  <input
                    v-model="form.company.name"
                    type="text"
                    class="form-control form-control-sm"
                    disabled
                  >
                </div>
                <div class="col-lg-6 mb-2">
                  <small class="font-weight-bold">
                    {{ $t('manage-master-data.company.label.code') }}
                  </small>
                  <input
                    v-model="form.company.code"
                    type="text"
                    class="form-control form-control-sm"
                    disabled
                  >
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6 mb-2">
                  <small class="font-weight-bold">
                    {{ $t('manage-master-data.company.label.work-location') }}
                  </small>
                  <input
                    v-model="form.workLocation"
                    type="text"
                    class="form-control form-control-sm"
                    disabled
                  >
                </div>
              </div>
              <div class="mb-2">
                <small class="font-weight-bold">
                  {{ $t('manage-master-data.contact-person.label.contact-person') }}
                </small>
                <div class="border border-secondary">
                  <div class="overflow-auto">
                    <div class="table-height">
                      <table class="table table-striped table-borderless">
                        <thead>
                          <tr class="row m-0 p-0">
                            <th
                              class="bg-white in-front-of col-4 p-2"
                            >
                              <small class="font-weight-bold">
                                {{ $t('manage-master-data.contact-person.label.type') }}
                              </small>
                            </th>
                            <th
                              class="bg-white in-front-of col-3 p-2"
                            >
                              <small class="font-weight-bold">
                                {{ $t('manage-master-data.contact-person.label.name') }}
                              </small>
                            </th>
                            <th
                              class="bg-white in-front-of col-4 p-2"
                            >
                              <small class="font-weight-bold">
                                {{ $t('manage-master-data.contact-person.label.phone') }}
                              </small>
                            </th>
                            <th
                              class="bg-white in-front-of col-1 p-2"
                            />
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(list, l) in listCp"
                            :key="l"
                            class="row m-0 p-0"
                          >
                            <td class="col-4 p-2">
                              <v-select
                                v-model="list.type"
                                label="name"
                                class="sm bg-white"
                                :options="typeContactPerson"
                                :reduce="getReduceId"
                              />
                            </td>
                            <td class="col-3 p-2">
                              <input
                                v-model="list.name"
                                type="text"
                                class="form-control form-control-sm"
                              >
                            </td>
                            <td class="col-4 p-2">
                              <input
                                v-model="list.phoneNumber"
                                type="text"
                                class="form-control form-control-sm"
                                :class="{'border border-danger': $v.listCp.$each.$iter[l].$error}"
                              >
                              <div
                                v-if="$v.listCp.$each.$iter[l].$error"
                                class="text-danger"
                              >
                                <small>
                                  {{ $t("manage-master-data.contact-person.numeric-phone-number") }}
                                </small>
                              </div>
                            </td>
                            <td class="col-1 p-2 text-center">
                              <a @click="deleteCp(l)">
                                <img
                                  src="@/assets/icon/delete.png"
                                  alt="delete"
                                >
                              </a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="bg-button py-3">
                    <button
                      class="col-2 ml-3 btn btn-info d-flex"
                      @click="addCp"
                    >
                      <img
                        src="@/assets/icon/add-white.png"
                        alt="add"
                        class="mr-4"
                      >
                      {{ $t('manage-master-data.add') }}
                    </button>
                  </div>
                </div>
              </div>
              <div class="mb-2">
                <p class="p-0 m-0">
                  <small class="font-weight-bold">
                    {{ $t('manage-master-data.contact-person.label.notif') }}
                  </small>
                </p>
                <small>
                  {{ $t('manage-master-data.contact-person.label.notif-warn') }}
                </small>
                <textarea
                  v-model="form.emailNotification"
                  class="form-control"
                  :class="{'border border-danger': $v.form.emailNotification.$error}"
                  rows="5"
                />
                <div
                  v-if="$v.form.emailNotification.$error"
                  class="text-danger"
                >
                  <small>
                    {{ $t("manage-master-data.contact-person.comma-allowed") }}
                  </small>
                </div>
              </div>
              <div>
                <small class="font-weight-bold">
                  {{ $t('manage-master-data.contact-person.label.admin-site') }}
                </small>
                <v-select
                  v-model="form.adminSite"
                  class="sm"
                  label="fullname"
                  multiple
                  :options="listAdminSite"
                  :reduce="getReduceId"
                />
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-center my-4">
            <button
              v-if="permission.permissions.includes('delete')"
              class="col-sm-3 btn btn-danger mx-2 py-2"
              @click="showModal('delete')"
            >
              {{ $t('manage-master-data.delete') }}
            </button>
            <button
              v-if="!isLoadingUpdate"
              class="col-sm-3 btn btn-info mx-2 py-2"
              @click="submit"
            >
              {{ $t('manage-master-data.save') }}
            </button>
            <button
              v-else
              class="col-sm-3 btn btn-info mx-2 py-2"
            >
              <div class="spinner-border spinner-border-sm">
                <span class="sr-only">
                  Loading...
                </span>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>

    <ModalUnsuccessful
      v-show="modal.unsuccessful"
      :text-modal="modal.textModal"
      @closeModal="closeModal"
    />
    <ModalSuccess
      v-show="modal.success"
      :text-modal="modal.textModal"
      @closeModal="closeModal"
    />

    <ModalDeleteCompany
      v-if="modal.delete"
      class="in-front-of"
      :id-company="id"
      :id-information="informationId"
      :name-information="form.workLocation"
      :name-company="form.company.name"
      @close="closeModal"
    />
  </portal>
</template>

<script>
import VSelect from 'vue-select'
import Api from '@/utils/Api'
import ModalUnsuccessful from '@/components/modal/ModalUnsuccessful'
import ModalSuccess from '@/components/modal/ModalSuccess'
import ModalDeleteCompany from './ModalDeleteCp'
import { numeric, alpha, helpers } from 'vuelidate/lib/validators'

export default {
  components: {
    VSelect,
    ModalUnsuccessful,
    ModalSuccess,
    ModalDeleteCompany
  },

  props: {
    id: {
      type: String,
      default: ''
    },
    informationId: {
      type: String,
      default: ''
    },
    permission: {
      type: Object,
      default: () => ({
        permissions: []
      })
    }
  },

  data: () => ({
    listCp: [],
    listAdminSite: [],
    isLoadingGet: false,
    isLoadingUpdate: false,
    form: {
      company: {
        name: '',
        code: ''
      },
      workLocation: '',
      emailNotification: '',
      adminSite: []
    },
    modal: {
      textModal: '',
      unsuccessful: false,
      success: false,
      delete: false
    },
    typeContactPerson: [
      { id: 'hsec', name: 'HSEC' },
      { id: 'hr', name: 'HR' },
      { id: 'doctor', name: 'Doctor' }
    ]
  }),

  async created () {
    this.isLoadingGet = true
    await this.getListAdminSite()
    await this.initial()
    this.isLoadingGet = false
  },

  methods: {
    getReduceId: ({ id }) => id,
    addCp () {
      this.listCp.push({
        type: '',
        name: '',
        phoneNumber: ''
      })
    },
    deleteCp (index) {
      this.listCp.splice(index, 1)
    },
    async getListAdminSite () {
      try {
        const { data } = await Api.users.list('')
        this.listAdminSite = data
      } catch ({ response }) {
        this.modal.textModal = response.statusText
        this.showModal('unsuccessful')
      }
    },
    async initial () {
      try {
        const { data } = await Api.companies.getInformation(this.id, this.informationId)
        this.form.company.name = data.name
        this.form.company.code = data.code
        this.form.workLocation = data.workLocation.name
        this.form.adminSite = data.administratorSiteUsers.map(element => element.id)
        this.form.emailNotification = data.emailNotification
        this.listCp = data.contactPersons.map(({ type, name, phoneNumber }) => ({ type, name, phoneNumber }))
      } catch ({ response }) {
        this.modal.textModal = response.statusText
        this.showModal('unsuccessful')
      }
    },
    showModal (modalname) {
      this.modal[modalname] = true
    },
    closeModal (modalname, isOpenEdit) {
      this.modal[modalname] = false
      if (!isOpenEdit) {
        this.$emit('close', 'editCp')
      }
    },
    async submit () {
      this.$v.$touch()
      if (this.$v.$invalid) return

      this.isLoadingUpdate = true
      const formUpdate = {}
      if (this.listCp.length) {
        formUpdate.contactPersons = this.listCp
      }
      if (this.form.adminSite.length) {
        formUpdate.administratorSiteUsers = this.form.adminSite
      }
      if (this.form.emailNotification) {
        formUpdate.EmailNotification = this.form.emailNotification
      }
      try {
        await Api.companies.updateInformation(this.id, this.informationId, formUpdate)
        this.modal.textModal = this.$t('manage-master-data.contact-person.success-update', { name: this.form.company.name })
        this.showModal('success')
        this.isLoadingUpdate = false
      } catch ({ response }) {
        this.isLoadingUpdate = false
        this.modal.textModal = response.statusText
        this.showModal('unsuccessful')
      }
    }
  },

  validations: {
    listCp: {
      $each: {
        phoneNumber: {
          numeric
        }
      }
    },
    form: {
      emailNotification: {
        alpha: helpers.regex(alpha, /^(?![,])(?!,*[,]{2})([a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*,*)+(?<![,])$/i)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  align-items: center;
  display: flex;
  padding-left: 0;
  z-index: 10;
}
.card {
  margin: 0 auto;
  width: 800px;
  border-radius: 18px;
}
.card-body {
  height: 450px !important;
}
.table-height {
  height: 250px;
}
.in-front-of {
  z-index: 10;
}
.table-striped > tbody > tr:nth-child(2n+1) > td, .table-striped > tbody > tr:nth-child(2n+1) > th {
  background-color: #F5F6FE;
}
.bg-button {
  background-color: #F5F6FE;
}
textarea {
  resize: none;
  font-size: 14px;
}
.in-front-of {
  z-index: 10000;
}

::v-deep(.vs__dropdown-toggle) {
  background: white;
}

::v-deep(.vs__selected-options) {
  flex-wrap: nowrap;

  .vs--open & {
    flex-wrap: wrap;
  }
}

</style>
